import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class InviteMembersService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private httpClient: HttpClient,
    private common: DatabaseCacheService
  ) { }

  inviteMembers(sectionId, postParam) {
    // let sectionId = this.common.getSelectedSection().sectionId;

    // this.storeAuth.getSection().subscribe((v) => {
    //   if (!v) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = v;
    //   }
    // });

    // this.httpOptions.headers = this.httpOptions.headers.set('LoginUserId', '21096fbe-444c-4887-9eb5-a025ec35dd2f');
    // this.httpOptions.headers = this.httpOptions.headers.set('FirstName', 'firstname');
    // this.httpOptions.headers = this.httpOptions.headers.set('LastName', 'lastname');

    // return this.httpClient.post(`${this.apiURL}/api/InviteMembers`, this.postParam, this.httpOptions);
    return this.httpClient.post(`${apiConfig.uri}/licence/${sectionId}/members/invitations`, postParam, this.httpOptions);
  }

}
